import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import CrossSell from "../pages/cross-sell";
import Navbar from "../components/navbar";
import Home from "../pages/home";

import {
	ApplicationInsights,
	ITelemetryPlugin,
} from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import BrandCost from "../pages/WhiteLabel";
import CustomerProfitability from "../pages/customer-profitability";
import CosttoServe from "../pages/CostToServe";
import Pricing from "../pages/pricing";

const reactPlugin = new ReactPlugin();

export const appInsights = new ApplicationInsights({
	config: {
		instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
		disableFetchTracking: false,
		enableAutoRouteTracking: true,
		extensions: [reactPlugin as unknown as ITelemetryPlugin],
		autoTrackPageVisitTime: true,
	},
});
appInsights.loadAppInsights();

const Router = () => {
	return (
		<BrowserRouter>
			<div className="flex flex-nowrap flex-col w-full h-full bg-lightWhite">
				<div className=" grow-0 shrink-0">
					<Navbar></Navbar>
				</div>
				<div className="basis-[85%] grow-0 shrink-0">
					<Routes>
						<Route
							path="/"
							element={<Navigate to="/home" />}
						/>
						<Route path="/cross-sell" element={<CrossSell />} />
						<Route path="/wlp" element={<BrandCost />} />
						<Route path="/customer-profitability" element={<CustomerProfitability />} />
						<Route path="/home" element={<Home />} />
						<Route path="/cts" element={<CosttoServe />} />
						<Route path="/pricing" element={<Pricing />} />
					</Routes>
				</div>
				<div className="border-t-[0.5px] border-lightGrey shadow-md fixed left-0 bottom-0 w-[100%] bg-white h-[4vh]"></div>
			</div>
		</BrowserRouter>
	);
};

export default Router;
